// extracted by mini-css-extract-plugin
export default {"title":"Hobbies_title__p1-o8","hobbySeparator":"Hobbies_hobbySeparator__nBLBE"};